// extracted by mini-css-extract-plugin
module.exports = {"headline":"FollowedCompanies-FollowedCompanies-headline-e7b5dfb5","followButton":"FollowedCompanies-FollowedCompanies-followButton-efa2751e"};